import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import BaseNavTabComponent from './base-nav-tab.component';

@Component({
  selector: 'evsb-nav-tabs',
  templateUrl: './base-nav-tabs.component.html',
  styleUrls: ['./base-nav-tabs.component.scss'],
})
export default class BaseNavTabsComponent implements AfterContentInit {
  @Input()
  public activateFirst = true;

  @ContentChildren(BaseNavTabComponent)
  public tabItems: QueryList<BaseNavTabComponent>;

  public get activeTab(): BaseNavTabComponent {
    return this.tabItems.find((tab: BaseNavTabComponent) => tab.active);
  }

  public activate(tab: BaseNavTabComponent) {
    this.tabItems.forEach((otherTab) => (otherTab.active = false));
    tab.active = true;
  }

  ngAfterContentInit(): void {
    setTimeout(() => this.activateFirstItem(), 0);
  }

  private activateFirstItem(): void {
    if (this.activateFirst && this.tabItems.first) {
      this.tabItems.first.active = true;
    }
  }
}
